/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import useProjectInfo from "../../hooks/useProjectinfo";
import ConnectButton from "../ConnectButton";
import Hamburger from "./Hamburger";
import ThemeSwitchButton from "../ThemeSwitchButton";
import { MediumSVG, TwitterSVG } from "../../utils/svgs";
import { scroller } from "react-scroll";

function TopBar() {
  const location = useLocation();
  const { curPage, setCurPage } = useProjectInfo();
  useEffect(() => {
    if (!location.pathname) return;
    const pathname = location.pathname.substring(1);
    setCurPage(pathname);
  }, [location]);

  const menus = ["Home", "Mint NFT", "Inventory", "About", "View Whitepaper"];
  const socials = [
    {
      link: "https://twitter.com/TrueapexFi?t=u4x5Yjtexb4Fai8NBug5wg&s=09",
      icon: TwitterSVG,
    },
    {
      link: "https://medium.com/@trueapexfinance_55238",
      icon: MediumSVG,
    },
  ];
  return (
    <div className="w-full bg-[#FFFFFFB0] absolute left-0 top-0 px-3 z-20">
      <Hamburger />
      <div className="w-full max-w-[1834px] mx-auto flex items-center xl:pr-5 pr-20 h-[122px] justify-between">
        <div className="flex items-center flex-1">
          <img src={"/logotext.png"} alt={""} className="mr-[50px]" />
          <div className="xl:flex hidden max-w-[670px] flex-1 justify-between 2xl:mx-10 mx-5">
            {menus.map((data, i) => {
              return i === 4 ? (
                <a
                  key={i}
                  target="_blank"
                  href={`https://trueapexfinances-organization.gitbook.io/product-docs/`}
                  className={`text-primary before:absolute before:w-0 before:context-[''] before:h-[2px]  before:bg-primary before:-bottom-3 before:transition-all before:duration-300 hover:before:w-full font-semibold relative `}
                  rel="noreferrer"
                >
                  {data}
                </a>
              ) : (
                <Link
                  key={i}
                  to={i === 3 ? "/home" : `/${data.replace(" ", "").toLowerCase()}`}
                  className={`${
                    curPage === data.toLowerCase().replace(" ", "")
                      ? "text-[blue]"
                      : "text-primary before:absolute before:w-0 before:context-[''] before:h-[2px]  before:bg-primary before:-bottom-3 before:transition-all before:duration-300 hover:before:w-full"
                  } font-semibold relative `}
                  onClick={() => {
                    if (i === 3)
                      setTimeout(() => {
                        scroller.scrollTo("About", {
                          duration: 1000,
                          delay: 0,
                          smooth: true,
                        });
                      }, 10);
                  }}
                >
                  {data}
                </Link>
              );
            })}
          </div>
        </div>
        <div className="flex items-center 2xl:mr-28 mr-0">
          <div className="hidden sm:flex text-primary items-center mr-5">
            {socials.map((data, i) => {
              return (
                <a
                  key={i}
                  target="_blank"
                  href={data.link}
                  rel="noreferrer"
                  className="mr-1 scale-[70%] hover:opacity-80 transition"
                >
                  {data.icon}
                </a>
              );
            })}
          </div>
          <div className="md:block hidden mr-[25px]">
            <ConnectButton />
          </div>
          <div className="xs:block hidden">
            <ThemeSwitchButton />
          </div>
        </div>
      </div>
    </div>
  );
}
export default TopBar;
